import { LoginService } from './../../login/services/login.service';
import { LoginGuardService } from './../../login/services/login-guard.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieManagerService } from '../../../shared/services/cookie-manager.service';
import { CookieNames, redirectionPoints, ApiEndpoints } from '../../constant';
import { LoginRedirectService, HttpClientService, CustomObserverService } from '../../../shared';
import { LocalStorageService } from 'angular-2-local-storage';
import { SubscriptionInfoService } from '../subscription-info-service.service';
declare var $: any;

@Component({
  selector: 'app-subscription-packs',
  templateUrl: './subscription-packs.component.html',
  styleUrls: ['./subscription-packs.component.css']
})
export class SubscriptionPacksComponent implements OnInit {

  packagesModal: any;
  public subscriptionPackages : Array<SubscriptionPackage> =[];

  private userId: any;
  public isUserLogged = false;
  private userCurrentPackageId: string;
  public subscriptionCount : number;
  constructor(
    private router: Router,
    private subscriptionInfoService: SubscriptionInfoService,
    private cookieManagerService: CookieManagerService,
    private loginRedirectService : LoginRedirectService,
    private httpClientService: HttpClientService,
    private localStorageService: LocalStorageService,
    private customObserverService: CustomObserverService,
    private loginService: LoginService

  ) {
    this.customObserverService.userId$.subscribe(value => {
      this.userId = value;
    });
    this.customObserverService.subscriptionCount$.subscribe(value => {
      this.subscriptionCount = parseInt(value);
    });
  }

  ngOnInit() {

    this.subscriptionPackages =[];
    this.subscriptionPackages = this.getSubscriptionTypes();
    this.subscriptionInfoService.currentPackageSourceMsg.subscribe(message => this.userCurrentPackageId = message);
    this.getUser();
    let packageId = this.localStorageService.get(CookieNames.userPackageId);
    this.userCurrentPackageId = packageId ? packageId.toString() : "";
  }

  ngAfterViewInit() {
    this.packagesModal = $('#packages-pop');
  }

  getUser() {
    let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);
    this.userId = userObj ? JSON.parse(userObj.toString())._id : null;
    this.subscriptionCount = parseInt(this.cookieManagerService.getCookie(CookieNames.subscriptionCount, false));
    return this.userId;
  }

   /**
   * modal close using hide event
   * 
   * @memberof AppLoginComponent
   */
  modalClose() {
    this.packagesModal.modal('hide');

  }

  clickonPackages(selectedPackage){
    this.subscriptionInfoService.selectPackage(selectedPackage);

    if (this.getUser()) {
      this.modalClose();
      this.router.navigate(['home/dialog-subscription-info']);
    }
    else {
      this.modalClose();
      $('#log-in-pop').modal('show');
      this.loginRedirectService.setRedirectPoint(redirectionPoints.subscriptionInfo);
      return;
    }
  }

  public  getSubscriptionTypes(){
    this.httpClientService.get(ApiEndpoints.getSubscriptionPackages).subscribe(response => {
      this.subscriptionPackages = response;
    });
    return this.subscriptionPackages;
  }

 
  
}

export class SubscriptionPackage
{
  _id: number;
  subscriptiontype: string;
  price: number;
  status: boolean;

}







// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/subscription-packages/subscription-packs/subscription-packs.component.ts